import FormBuilder from "components/Inputs/FormBuilder";
import { DataFields } from "./DataFields";

export default function HeaderModule({ dataInstance, register, errors, changeDataFunction, setFieldImageManager, openImageManager, changeCompletePicker }) {

  return (<>
    <FormBuilder 
      dataDields={DataFields}
      dataInstance={dataInstance}
      register={register}
      errors={errors}
      changeDataFunction={changeDataFunction}
      setFieldImageManager={setFieldImageManager}
      openImageManager={openImageManager}
      changeCompletePicker={changeCompletePicker}
    />
  </>)
}